export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", max = 180) {
  const clean = stripHtml(value);

  if (clean.length <= max) return clean;

  return `${clean.slice(0, max - 1)}…`;
}

export function formatDateTime(value) {
  if (!value) return "Date inconnue";

  const raw = String(value).trim();

  const match = raw.match(
    /^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/,
  );

  if (!match) return "Date inconnue";

  const [, yyyy, mm, dd, hh, mi] = match;

  if (!hh || !mi) {
    return `${dd}/${mm}/${yyyy}`;
  }

  return `${dd}/${mm}/${yyyy} à ${hh}:${mi}`;
}

export function buildPublicationsSearchParams({
  q,
  stateFilter,
  page,
  limit,
}) {
  return {
    q: q?.trim() || undefined,
    is_active:
      stateFilter === "all"
        ? undefined
        : stateFilter === "active"
          ? true
          : false,
    page,
    limit,
    sort: "created_at",
    dir: "DESC",
  };
}

export function normalizePublicationForm(form) {
  return {
    titre: form.titre.trim(),
    description: form.description || "",
    image_publication_url: form.image_publication_url?.trim() || "",
    lien_publication_url: form.lien_publication_url?.trim() || "",
    is_active: !!form.is_active,
  };
}

export function validatePublicationForm(form) {
  const errors = {};

  if (!form.titre?.trim()) {
    errors.titre = "Le titre est obligatoire.";
  }

  return errors;
}

export function getPublicationUrlLabel(url = "") {
  const clean = String(url || "").trim();

  if (!clean) return "Aucun lien";

  if (clean.startsWith("http")) return "Lien externe";

  if (clean.toLowerCase().includes(".pdf")) return "Document PDF";

  return "Lien interne";
}

export function getPublicationsStats(items = [], total = 0) {
  const activeOnPage = items.filter((item) => !!item.is_active).length;
  const inactiveOnPage = items.filter((item) => !item.is_active).length;
  const withImageOnPage = items.filter(
    (item) => !!item.image_publication_url,
  ).length;
  const withLinkOnPage = items.filter(
    (item) => !!item.lien_publication_url,
  ).length;

  return {
    total,
    activeOnPage,
    inactiveOnPage,
    withImageOnPage,
    withLinkOnPage,
  };
}